import { render, staticRenderFns } from "./ModalImportStudentCsv.vue?vue&type=template&id=aebabc8e&scoped=true&lang=pug&"
import script from "./ModalImportStudentCsv.vue?vue&type=script&lang=ts&"
export * from "./ModalImportStudentCsv.vue?vue&type=script&lang=ts&"
import style0 from "./ModalImportStudentCsv.vue?vue&type=style&index=0&id=aebabc8e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebabc8e",
  null
  
)

export default component.exports